import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              话题标签
            </h2>
            <p className="text-sm text-foreground-500">
              热门吃瓜话题一键直达，跟着标签找到更多精彩内容
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicItems.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-300 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap ${
                  item.isHot
                    ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {item.name}
                <span className={`text-xs ${
                  item.isHot ? 'text-primary-500' : 'text-foreground-500'
                }`}>
                  {item.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}